import React, { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { theme } from './styles/theme';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import { AssessmentProvider } from './context/AssessmentContext';

// Pages
import NachosProcessPage from './pages/NachosProcessPage';
import AssessmentResultsPage from './pages/AssessmentResultsPage';
import AssessmentLandingPage from './pages/AssessmentLandingPage';

// Home page components
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import MethodologyIntro from './components/MethodologyIntro';
import ProcessSection from './components/ProcessSection';
import IsThisForYouSection from './components/IsThisForYouSection';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

// Section theme configuration
const SECTION_THEMES = {
  hero: { bg: 'charcoal', isDark: true },
  problem: { bg: 'bone', isDark: false },
  methodology: { bg: 'charcoal', isDark: true },
  process: { bg: 'charcoal', isDark: true },
  testimonials: { bg: 'charcoal', isDark: true },
  'is-this-for-you': { bg: 'bone', isDark: false },
  'next-steps': { bg: 'gold', isDark: false },
  faq: { bg: 'bone', isDark: false }
};

const HomePage = () => {
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section[id]');
      const headerHeight = 100; // Header height offset

      // Find which section is currently at the top of the viewport
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        const rect = section.getBoundingClientRect();

        // If the section top is above or at the header
        if (rect.top <= headerHeight) {
          setActiveSection(section.id);
          break;
        }
      }
    };

    // Initial check
    handleScroll();

    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const sectionTheme = SECTION_THEMES[activeSection] || SECTION_THEMES.hero;

  return (
    <>
      <Header isDark={sectionTheme.isDark} />
      <main>
        <Hero />
        <ProblemSection />
        <MethodologyIntro />
        <ProcessSection />
        <IsThisForYouSection />
        <Testimonials />
        <FAQSection />
      </main>
    </>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <AssessmentProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/nachos-process" element={<NachosProcessPage />} />
            <Route path="/assessment-results" element={<AssessmentResultsPage />} />
            <Route path="/assess-my-deck" element={<AssessmentLandingPage />} />
          </Routes>
          <Footer />
        </AssessmentProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
